module.exports = __webpack_public_path__ + "img/jifen.39dc345b.png";